import { styled } from 'styled-components';
import Input from '../../../components/utils/Input/Input';
import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;
export const LeftSide = styled.div`
  display: flex;
  min-width: 240px;
  height: fit-content;
  padding: 32px 24px;
  flex-direction: column;
  align-items: ${props => (props.$loading ? 'center' : 'flex-start')};
  justify-content: ${props => (props.$loading ? 'center' : 'flex-start')};
  gap: 24px;
  height: ${props => (props.$loading ? '577px' : 'auto')};
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
`;
export const RightSide = styled.div`
  display: flex;
  width: 739px;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  min-height: 577px;
  @media (max-width: 1020px) {
    width: 100%;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: ${props =>
    props.$selected
      ? '1px solid #f1e6e2'
      : props.$payment
      ? '1px solid #F1F8FF'
      : props.$appointments
      ? '1px solid #F9DDE2'
      : '1px solid #f1e6e2'};
  flex-wrap: wrap;
`;
export const TabName = styled.span`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  flex: 1 0 0;
  text-align: center;
  min-width: 135px;
  border-radius: 10px 10px 0px 0px;
  background: ${props =>
    props.$selected ? '#f1e6e2' : props.$payment ? '#F1F8FF' : props.$appointments ? '#F9DDE2' : '#fff'};

  cursor: pointer;
  user-select: none;

  font-family: 'Poppins-Medium';

  font-size: 15px;

  letter-spacing: -0.408px;
`;

export const ProfileHeader = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;
export const Name = styled.span`
  color: #000;
  font-family: Playfair Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;
export const Title = styled.span`
  user-select: none;
  font-size: 13px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.2px;
  opacity: 0.5;
`;
export const Info = styled(Title)`
  user-select: auto;
  opacity: 1;
`;
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
  width: 100%;
`;
export const Gap = styled.div`
  gap: 4px;
  flex-direction: column;
  display: flex;
`;

export const DeleteText = styled.span`
  cursor: pointer;
  color: #c70000;
  user-select: none;
  font-size: 13px;
  font-family: 'Poppins-Regular';

  letter-spacing: -0.2px;
  &:hover {
    text-decoration: underline;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;

export const TabTitle = styled.span`
  color: #000;
  font-family: Playfair Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;
export const AddText = styled.span`
  text-align: right;
  font-family: 'Poppins-Medium';

  font-size: 14px;

  letter-spacing: -0.408px;
`;
export const AddButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  &:active {
    opacity: 0.6;
  }
`;
export const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  flex-wrap: wrap;
  gap: 12px;
  @media (max-width: 335px) {
    justify-content: center;
    padding-right: 0px;
  }
`;
export const ContentContainer = styled.div`
  padding: 24px 5px 24px 24px;
  position: relative;
  flex: 1;
  width: 100%;
  max-height: 709px;
`;

export const Content = styled.div`
  max-height: 425px;
  flex: 1;
  margin-top: 16px;
  display: flex;
  gap: ${props => (props.$noGap ? '0px' : '16px')};
  flex-direction: column;
  overflow-y: scroll;
  padding-right: 5px;
`;
export const ContractContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: space-between;
  @media (max-width: 450px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ContractInfoMediaContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  @media (max-width: 450px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ContractInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  justify-content: center;

  @media (max-width: 450px) {
    align-items: center;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  justify-content: center;
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  gap: 6px;
`;
export const Date = styled.span`
  font-family: 'Poppins-Regular';

  font-size: 12px;

  line-height: 22px; /* 183.333% */
  letter-spacing: -0.408px;
`;
export const ContractName = styled.span`
  font-size: 16px;
  font-family: 'Poppins-SemiBold';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
`;

export const NoData = styled.span`
  font-size: 16px;
  font-family: 'Poppins-SemiBold';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
  text-align: center;
`;
export const UploadedBy = styled.span`
  font-family: 'Poppins-Medium';

  font-size: 14px;

  line-height: 22px; /* 157.143% */
  letter-spacing: -0.408px;
  opacity: ${props => (props.$opacity ? 0.5 : 1)};
`;

export const PaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 10px;
  border: 1px solid #e1ecf7;
  background: #fbfdff;
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  align-self: stretch;
`;
export const PaymentRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

export const PaymentDescRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
export const PaymentDate = styled.span`
  text-align: center;
  font-family: 'Poppins-Medium';

  font-size: 14px;

  letter-spacing: -0.2px;
`;
export const PaymentStatus = styled(PaymentDate)`
  font-weight: 600;
`;
export const PaymentAmount = styled(PaymentDate)`
  font-size: 16px;
  align-self: flex-start;
`;
export const PaymentMethodType = styled(PaymentDate)`
  font-size: 16px;
  opacity: 0.4;
`;
export const PaymentTotal = styled(PaymentDate)`
  font-size: 20px;
  font-weight: 600;
`;
export const PaymentTotalText = styled(PaymentDate)`
  font-size: 16px;
`;
export const TotalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #e1ecf7;
  background: #deeaf6;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  flex-wrap: wrap;
`;

export const TotalClientAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const ToDoContainer = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #feeae6;
  background: #fffdfc;
`;

export const ToDoContainerDateDelete = styled.div`
  display: flex;

  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: end;
  gap: 8px;
`;

export const ToDoHeaderIconsContainer = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 24px;
  flex-wrap: wrap;
  @media (max-width: 335px) {
    align-items: center;
    justify-content: center;
  }
`;
export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
export const ToDoName = styled.span`
  font-family: 'Poppins-Medium';

  text-align: center;

  font-size: 16px;

  letter-spacing: -0.408px;
`;
export const ToDoContainerCompleted = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #feeae6;
  background: #f7f7f7;
`;
export const ToDoNameCompleted = styled.span`
  text-align: center;

  font-size: 16px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;
  text-decoration-line: line-through;
`;
export const ToDoVendor = styled.span`
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Poppins-Regular';

  font-size: 16px;

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
  opacity: 0.5;
`;

export const ToDoDate = styled.span`
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Poppins-Regular';

  font-size: 16px;

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
`;

export const ToDoCompleted = styled.span`
  color: rgba(0, 0, 0);
  font-family: 'Poppins-Regular';

  font-size: 16px;

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
`;
export const Dot = styled(ToDoVendor)`
  font-weight: 250;
`;
export const AppointmentContainer = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  &:hover {
    background-color: rgba(245, 237, 239, 0.35);
    transition: all 0.2s ease-in-out;
  }
`;
export const AppointmentDate = styled.span`
  text-align: center;
  font-family: 'Poppins-Medium';

  font-size: 15px;

  letter-spacing: -0.2px;
`;
export const AppointmentName = styled(AppointmentDate)`
  font-size: 14px;
`;
export const DateBox = styled.div`
  display: flex;
  min-width: 40px;
  min-height: ${props => (props.$height ? '40px' : '46px')};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  background: #fceef1;
  padding-inline: 5px;
`;
export const NameBox = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 10px;
  border: 1px solid #f9dde2;
  background: #fceef1;
`;

export const ProfilePhoto = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: linear-gradient(0deg, #f1e4df 0%, #f1e4df 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonAccept = styled.button`
  display: flex;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 1.04%, rgba(0, 0, 0, 0.5) 100%), #262626;
  box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1);
  color: #fffdfc;
  text-align: justify;
  font-family: 'Poppins-Medium';

  font-size: 14px;

  line-height: 22px; /* 157.143% */
  letter-spacing: -0.408px;
  border: none;
  cursor: pointer;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const ButtonReject = styled(ButtonAccept)`
  color: #be6a59;
  background: white;
  box-shadow: none;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const Remove = styled(Delete)`
  path {
    stroke: #fff;
  }
  cursor: pointer;

  &:hover {
    path {
      stroke: red;
    }
  }
`;
export const RemoveIcon = styled.div`
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(1.2px);
  -webkit-backdrop-filter: blur(1.2px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
export const RowIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  position: absolute;
`;
export const ListContainer = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: absolute;
  left: 0px;
  top: 32px;
  z-index: 1000;
  width: 100%;
  background-color: white;
  border-bottom: 1px solid #e2dddb;
  border-left: 1px solid #e2dddb;
  padding: 12px;
  border-right: 1px solid #e2dddb;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  height: fit-content;
`;
export const DropdownContainer = styled.div`
  position: relative;
  cursor: pointer;
  align-items: center;
  display: flex;
`;

export const Dropdown = styled.div`
  width: 100%;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 12px;
  height: 32px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  border-bottom-left-radius: ${props => (props.$open ? '0px' : '8px')};
  border: ${props => (props.$open ? '1px solid #000' : '1px solid #e2dddb')};
`;
export const DropText = styled.span`
  font-family: 'Poppins-Medium';

  opacity: 0.8;

  font-size: 13px;

  letter-spacing: -0.408px;
`;
export const DropValue = styled(DropText)`
  color: #000;
  border-bottom: 1px solid #f3e6e1;
  user-select: none;
  &:hover {
    opacity: 0.6;
  }
`;

export const CurrentDropValue = styled(DropText)`
  color: #000;
  user-select: none;
  &:hover {
    opacity: 0.6;
  }
`;
export const SelectValue = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonAdd = styled.button`
  display: flex;
  cursor: pointer;
  padding: 16px;
  margin-top: 16px;
  justify-content: center;
  gap: 8px;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #f3e6e1;
  background: #fcf7f6;
  width: 100%;

  color: #000;
  text-align: center;

  font-size: 18px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;
export const TotalText = styled.span`
  font-family: 'Poppins-SemiBold';

  font-size: 20px;

  letter-spacing: -0.2px;
`;
export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ButtonModalCancel = styled.button`
  border-radius: 16px;
  border: 1px solid #be6a59;
  display: flex;
  width: 160px;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: white;
  cursor: pointer;

  color: #1e1e1e;
  text-align: justify;
  font-family: 'Poppins-Medium';

  font-size: 16px;

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const ModalTitle = styled.span`
  color: #000;
  text-align: justify;
  font-family: Playfair Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const IconPosition = styled.div`
  position: absolute;
  top: 13px;

  cursor: pointer;
  right: 24px;
`;
export const ButtonModal = styled(ButtonModalCancel)`
  background: #f1e4df;
  border: none;
`;
export const Total = styled.span`
  font-family: 'Poppins-Medium';

  font-size: 18px;
  letter-spacing: -0.2px;
  opacity: 0.5;
`;

export const TotalAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
`;
export const TitleSmall = styled.span`
  text-align: justify;
  font-family: 'Poppins-SemiBold';

  margin-top: 8px;
  margin-bottom: -8px;
  font-size: 18px;

  letter-spacing: -0.2px;
`;
export const RowModal = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const ButtonUpload = styled.button`
  border-radius: 16px;
  border: 1px solid #f3e6e1;
  background: #fcf7f6;
  display: flex;
  padding: 16px;
  cursor: pointer;
  justify-content: center;
  gap: 8px;
  align-items: center;
  align-self: stretch;
  width: 49%;
`;

export const TooltipBox = styled.div`
  visibility: hidden;
`;
export const TooltipCard = styled.div`
  & ${RowIcon}:hover + ${TooltipBox} {
    visibility: visible;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.6);
    height: '100%';
    top: -5px;
    left: 50%;
    border-radius: 4px;
    position: relative;
    z-index: 10;
  }
`;

export const ToolTipTitle = styled.span`
  color: #fff;
  text-align: center;
  font-family: 'Poppins-Regular';

  font-size: 11px;

  letter-spacing: -0.2px;
  padding: 5px 5px;
`;

export const UploadContainer = styled.div`
  transition: all 0.2s ease-in-out;
  min-height: 317px;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  border-radius: 16px;
  background: #fcf7f6;
  border: 1px solid #f3e6e1;
  width: 49%;
  gap: 8px;
  padding: 16px;

  cursor: ${props => (props.$selected ? 'default' : 'pointer')};
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  align-items: center;
  gap: 24px;
`;

export const ContractImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: center;
  gap: 24px;
`;
export const AddPhotoContainer = styled.div`
  transition: all 0.2s ease-in-out;
  height: 254px;
  width: 199px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  border-radius: 16px;
  background: #fbf4f2;
  border: 1px solid #f3e6e1;
  gap: 8px;
  padding: 16px;
  cursor: pointer;
  position: relative;
`;

export const ImagePreview = styled.img`
  width: 254px;
  height: 254px;
  object-fit: cover;
  border-radius: 10px;
`;

export const ImagePreviewBig = styled.img`
  width: 620px;
  object-fit: cover;
  height: auto;
  border-radius: 10px;
`;
export const InputImage = styled.input`
  position: absolute;
  height: 254px;
  width: 199px;
  border-radius: 10;
  opacity: 0;
  top: 0;
  left: 0;
  cursor: pointer;
`;

export const PdfContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: center;
  gap: 24px;
  height: 254px;
`;

export const PdfContainerDetails = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: center;
  gap: 24px;
  width: 850px;
  height: 1200px;
`;

export const ClientProfilePhoto = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 16px;
`;

export const SlotsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const SlotContainer = styled.div`
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  background: #f1e4df;
  padding: 8px;
  justify-content: center;
  border: 1px solid #f1e4df;
`;

export const SelectedSlotContainer = styled(SlotContainer)`
  background: #fff;
  border: 1px solid #be6a59;
  cursor: pointer;
`;

export const SelectedSlotForEditContainer = styled(SelectedSlotContainer)`
  width: 100px;
`;

export const CurrentSlotContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 10px;
`;

export const SlotsTitle = styled.span`
  font-size: 18px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.2px;
  margin-left: 5px;
`;

export const SlotName = styled.span`
  font-family: 'Poppins-Regular';
  text-align: center;
  font-size: 16px;

  line-height: 25px;
  letter-spacing: 0.38px;
`;
export const Scroll = styled.div`
  overflow: auto;
  height: 550px;
`;
export const LoaderContainer = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const StyledInputLast = styled(StyledInput)`
  margin-bottom: 8px;
`;
export const PdfUpload = styled.input`
  background: red;
  width: 250px;
  position: absolute;
  height: 317px;
  border-radius: 10px;
  opacity: 0;
  cursor: pointer;
`;
export const ImgUpload = styled.input`
  background: red;
  width: 250px;
  position: absolute;
  height: 317px;
  border-radius: 10px;
  opacity: 0;
  cursor: pointer;
`;

export const TextArea = styled.textarea`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    opacity: 0.5;
  }
  font-family: 'Poppins-Medium';

  font-size: 16px;

  letter-spacing: -0.2px;
`;

export const HashtagContainer = styled.div`
  display: flex;
  border-radius: 4px;
  background: #f1e4df;
  padding: 8px;
  justify-content: center;
  gap: 5px;
`;

export const HashtagName = styled.span`
  text-align: center;
  font-family: 'Poppins-Regular';

  font-size: 16px;

  line-height: 25px;
  letter-spacing: 0.38px;
`;

export const HashtagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ClientHashtagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
`;

export const HashContainer = styled.div`
  display: flex;
`;

export const SubtitlePayments = styled.span`
  font-size: 16px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;
`;

export const Error = styled.span`
  color: red;
  text-align: justify;
  font-family: 'Poppins-SemiBold';

  //margin-top: 8px;
  //margin-bottom: -8px;
  font-size: 16px;

  letter-spacing: -0.2px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
